export const isMobileWebClient = (): boolean => {
  if (typeof window === "undefined") return false;

  const ua = navigator.userAgent || navigator.vendor || (window as any).opera || "";
  return /android|iphone|ipad|ipod/i.test(ua) || window.matchMedia("(max-width: 900px)").matches;
};

export const isTransientNetworkError = (error: unknown): boolean => {
  const message = String((error as any)?.message || error || "");

  return /Network Error|TypeError: Load failed|Load failed|Failed to fetch|NSURLErrorDomain|ERR_NETWORK|The operation couldn’t be completed/i.test(
    message
  );
};
